export default "__VITE_ASSET__CACXpAp8__"